import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { Legend, LoaderWrapper, ReportHeading, ReportOuterWrapper } from '../../../../components'
import { useGlobalStore } from '../../../../store'
import ComparisonTable from './comparisonTable'
import ProgressionRange from './progressionRange'
import DriversProgressionPopup from './driversProgressionPopup'
import { ContentWrap, RootWrap, GridHeaderWrapper, SegmentTableWrapper } from './style'
import { useComparisonData } from './useComparisonData'
import { usePopupDropdownArray } from './usePopupDropdownArray'
import SegmentTable from '../reportSegmentV2/segmentTable'
import ReportsService from '../../../../services/reports.service'
import { getProgressionArray, fakeDelay } from '../../../../util'
import Header from '../reportSegment/header'
import NewComponent from './newComponent'
import ReportSegmentV2 from '../reportSegmentV2'

const ComparisonViewDeepDiveNew = (props) => {
  const [progressionRangeObject, setProgressionRangeObject] = useState({})
  const { driverProgressionPopupObject, setDriverProgressionPopupObject } = useGlobalStore()
  // const [showTableGrid, setShowTableGrid] = useState('graph')

  // Use custom hooks
  const {
    state,
    segmentData,
    reportData,
    maxValue,
    segmentExcelData,
    periodInOrder,
    eventCount,
    setEventCount,
    progressionRangeArray,
    popupDropdownArray,
    keyOrdering,
    isLoading,
    isSuccess,
    isError,
    error,
    CONFIG,
  } = useComparisonData(props)

  const popupDropdownArrayWithAllMonths = usePopupDropdownArray(
    keyOrdering,
    popupDropdownArray,
    props.InsightsElementType
  )

  // Track expanded status
  const [expandedStatus, setExpandedStatus] = useState(false)
  const [activeTab2, setActiveTab2] = useState(0)
  const [reportDataNew, setReportDataNew] = useState()
  const [isNewComponent, setIsNewComponent] = useState('')

  const legendsData = [
    { label: 'Positive', value: 'Positive' },
    { label: 'Neutral', value: 'Neutral' },
    { label: 'Mixed', value: 'Mixed' },
    { label: 'Negative', value: 'Negative' },
  ]

  // Update expanded status from props
  useEffect(() => {
    if (props?.driversSegmentsExpanded) {
      setExpandedStatus(true)
    }
  }, [props?.driversSegmentsExpanded])

  // Update popup dropdown object in store
  useEffect(() => {
    if (popupDropdownArray?.length > 0) {
      setDriverProgressionPopupObject({
        ...driverProgressionPopupObject,
        popupDropdownArray: popupDropdownArray,
      })
    }
  }, [popupDropdownArray])

  useEffect(() => {
    setReportDataNew(reportData)
  }, [reportData])

  useEffect(() => {
    setReportDataNew(reportData)
  }, [])

  const AdditionalButtons = () => {
    return reportDataNew?.length > 0 ? (
      <ProgressionRange
        data={progressionRangeArray}
        progressionRangeObject={progressionRangeObject}
        setProgressionRangeObject={setProgressionRangeObject}
      />
    ) : null
  }

  const activeTab2_dataArray = async () => {
    if (activeTab2 === 1) {
      let idArray = [...reportDataNew].slice(0, progressionRangeObject.barsInGraph).filter(f => !f?.hasDataFromServer)?.map((item) => item.PeriodInsightsElementId) || []
      const totalLen = progressionRangeObject.barsInGraph

      const allResponses = await Promise.all(
        idArray.map(async (id) => {
          await fakeDelay(1000);

          return await ReportsService.reportGetDriverElementsApi({
            insightsElementId: id,
            entityId: props?.EntityId,
            type: ['SearchDriversProgression', 'SearchDriversProgression3Level'].includes(props.InsightsElementType) ? '__SearchDrivers' : null
          });
        })
      )

      const decodedResponsesObject = {}
      const decodedResponses = allResponses.map((resp, i) => {
        decodedResponsesObject['id_'+idArray[i]] = resp.respData
        return {['id_'+idArray[i]] : resp.respData}
      })

      const finalData = reportDataNew.map((d, i) => {
        if( decodedResponsesObject?.['id_'+d.PeriodInsightsElementId] && decodedResponsesObject['id_'+d.PeriodInsightsElementId]?.length > 0 ){
          d.PeriodDrivers.DriverElement = decodedResponsesObject['id_'+d.PeriodInsightsElementId]
          d.SegmentDrivers.DriverElement = decodedResponsesObject['id_'+d.PeriodInsightsElementId]
          d['hasDataFromServer'] = true
        }
        return d
      })

      setReportDataNew(finalData)
    }
  }

  useEffect(() => {
    activeTab2_dataArray()
  }, [activeTab2, progressionRangeObject])

  useEffect(() => {
    console.log('progressionRangeObject=========', progressionRangeObject)
  }, [progressionRangeObject])

  useEffect(() => {
    if (keyOrdering.length === 0 && popupDropdownArray.length > 0) {
      setIsNewComponent('OLD_COMPONENT');
    } else if (keyOrdering.length > 0 && popupDropdownArray.length > 0) {
      const firstKeys = keyOrdering[0]?.toLowerCase().replace(/\s+/g, '')
      const firstKey = firstKeys.replace(/fy\d{2}/gi, '')

      const arr = [
        'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
        'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august',
        'september', 'october', 'november', 'december',
        'phase1', 'phase2', 'phase3', 'phase4',
        't1', 't2', 't3',
        'q1', 'q2', 'q3', 'q4',
        'h1', 'h2'
      ]

      const isValidKey =
        arr.includes(firstKey) ||
        /^(phase\d+|t\d+|q\d+|h\d+|jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/.test(firstKey)

      setIsNewComponent(isValidKey ? 'NEW_COMPONENT' : 'OLD_COMPONENT')
    }
  }, [keyOrdering, popupDropdownArray])
  
  return (
    <>
      {isNewComponent === 'NEW_COMPONENT' && <>
      {reportDataNew?.length > 0 && (
        <ReportHeading
          resetInsightHeight={eventCount}
          downloadId={props.type}
          {...props}
          additionalButton={isNewComponent === 'NEW_COMPONENT' && <AdditionalButtons />}
          downloadIdData={segmentExcelData}
          addTable={true}
          graphBtn={true}
        />
      )}
      
      <ReportOuterWrapper>
        <RootWrap
          id={props.type}
          className={`${props.InsightsElementType} ${
            props?.isPPTModalActive || props?.isProgressionActive ? 'exportToPPT' : ''
          }`}
        >
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            <NewComponent
              activeTab2={activeTab2}
              setActiveTab2={setActiveTab2}
              segmentData={segmentData}
              eventCount={eventCount}
              progressionRangeObject={progressionRangeObject}
              props={props}
              keyOrdering={keyOrdering}
              maxValue={maxValue}
              state={state}
              CONFIG={CONFIG}
              expandedStatus={expandedStatus}
              setEventCount={setEventCount}
              periodInOrder={periodInOrder}
              progressionRangeArray={progressionRangeArray}
              popupDropdownArray={popupDropdownArray}
              popupDropdownArrayWithAllMonths={popupDropdownArrayWithAllMonths}
              driverProgressionPopupObject={driverProgressionPopupObject}
              reportDataNew={reportDataNew}
              legendsData={legendsData}
            />
          </LoaderWrapper>
        </RootWrap>
      </ReportOuterWrapper>          
            </>}
            {isNewComponent === 'OLD_COMPONENT' && <>
              <ReportSegmentV2 {...props}/>
            </>}
    </>
  )
}

export default ComparisonViewDeepDiveNew

